import { put, select } from 'redux-saga/effects';
import nsApi from '@netsapiens/netsapiens-js/dist/api';

import * as actions from '../../../state';
import { userAuthenticated, subscriberSelect, ssoEnroll } from '../../../events';

export default function* ssoLoginUser(event) {
  yield put(actions.showLoaderPage());

  const apiHash = yield select((state) => state.configs.apiHash);

  try {
    const params = {
      idtoken: event.payload.idtoken,
      vendor: event.payload.vendor,
      username: event.payload.username || null,
      apiHash,
    };

    yield nsApi.ssoLogin(params);
    yield put(actions.loginFormErrorMsg(null));
    yield put(userAuthenticated());
  } catch (err) {
    if (err === 'NO_SUBSCRIBER') {
      yield put(actions.loginFormErrorMsg(null));
      yield put(ssoEnroll(
        event.payload.idtoken,
        event.payload.vendor,
      ));
    } else if (err.reason === 'SELECT_SUBSCRIBER') {
      yield put(actions.loginFormErrorMsg(null));
      yield put(subscriberSelect({
        idtoken: event.payload.idtoken,
        vendor: event.payload.vendor,
        subscriber_list: err.subscriber_list,
      }));
    } else {
      console.error('ssoLoginUser error', err);
      yield put(actions.loginFormErrorMsg('Login failed. Please try again.'));
      yield put(actions.showLoginFormPage());
    }
  }
}
